import clsx from 'clsx'

import styles from './icon.module.css'
import type { IconDefaultProps } from './types'

const Copy = ({ className }: IconDefaultProps): JSX.Element => (
  <svg
    className={clsx(styles.icon, className)}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.6433 16.25C10.2924 16.25 10.0195 16.5625 10.0195 16.875V17.5C10.0195 18.2031 9.4347 18.75 8.77193 18.75H2.53411C1.83236 18.75 1.28655 18.2031 1.28655 17.5V7.5C1.28655 6.83594 1.83236 6.25 2.53411 6.25H6.90058C7.21248 6.25 7.52437 5.97656 7.52437 5.625C7.52437 5.3125 7.21248 5 6.90058 5H2.49513C1.1306 5 0 6.13281 0 7.5L0.0389864 17.5C0.0389864 18.9062 1.1306 20 2.53411 20H8.77193C10.1365 20 11.2671 18.9062 11.2671 17.5V16.875C11.2671 16.5625 10.9552 16.25 10.6433 16.25ZM19.6101 3.39844L16.6082 0.390625C16.3743 0.15625 16.0624 0 15.7115 0H11.2671C9.86355 0 8.77193 1.13281 8.77193 2.5V12.5C8.77193 13.9062 9.86355 15 11.2671 15H17.5049C18.8694 15 20 13.9062 20 12.5V4.29688C20 3.94531 19.8441 3.63281 19.6101 3.39844ZM16.2573 1.79688L18.2066 3.75H16.2573V1.79688ZM18.7524 12.5C18.7524 13.2031 18.1676 13.75 17.5049 13.75H11.2671C10.5653 13.75 10.0195 13.2031 10.0195 12.5V2.5C10.0195 1.83594 10.5653 1.25 11.2671 1.25H15.0097V3.75C15.0097 4.45312 15.5556 5 16.2573 5H18.7524V12.5Z'
      fill='#707780'
    />
  </svg>
)

export default Copy
